import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';
import clsx from "clsx";

import Sidebar from '../../../components/sidebar/Sidebar';
import HeaderBtn from "../../../components/headerBtn/headerBtn";

import FiredEmployees from '../../../pages/employees/firedEmployees/firedEmployees';

import SectionContent from '../../../components/sectionContent/sectionContent';

import '../../../scss/App.scss';
import { IUserOptions } from '../../../types/interfaces';

const FiredEmployeesSection = () => {
	const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);

	const overflowedBtnsCount = 0;
	const isOpenGroupBtn = false;
	
	const availableButtons = [
    {
      component: (
        <HeaderBtn
          content='Настройки'
          purpose='firedListSettings'
          modalTitle='Настройки'
        />
      )
    },
    {
      component: (
        <HeaderBtn
          content='Выгрузить список'
          purpose='unloadStafftReport'
          modalTitle='Выгрузить список'
					hasIcon='excel'
        />
      ),
    },
    {
      component: (
        <HeaderBtn
          content='Выгрузить измененные'
          purpose='unloadModifiedData'
          modalTitle='Выгрузить список изменения сотрудников'
					hasIcon='excel'
        />
      ),
    },
  ];

	const filteredAvailableButtons = availableButtons.filter((btn: any) => btn);

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: any, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

    return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				headBlockChildren={displayedHeadBtns}
				isOpenGroupBtn={isOpenGroupBtn}
				pageName='projectInfo'
				section='Сотрудники'
        title='Уволенные'
			>
				<div className='content__main'>
					<div className={clsx(
						isOpenSidebar &&
						"btns_active",
						!isOpenSidebar && "btns_close",
						'btns'
					)}>
						<Link to={`/employees`} className='tab'>
							<div className='buttons__btn'>Действующие</div>
						</Link>
						{(
								<Link
                to={'/employees/fired'}
                className='tab'
								>
									<div className='buttons__btn --active'>Уволенные</div>
								</Link>
							)}
						{<Link
							to={''}
							className='tab'
						>
							<div className='buttons__btn'>Документы</div>
						</Link>}
					</div>
					<FiredEmployees />
				</div>
			</SectionContent>
		</div>
	);
};

export default FiredEmployeesSection;